module.exports = __webpack_public_path__ + "static/media/benefitsSpecialAlarm@2x.4d2b72c3.jpg";